<template>
  <div class="detail-page">
    <div class="content" v-html="message"></div>
  </div>
</template>

<script>
let url = {
  gene_seq: 'species/gene_seq',
  lncRNA_seq: 'species/lncRNA_seq',
  lncRNA_polt: 'species/lncRNA_polt'
}
export default {
  data() {
    return {
      message: ''
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let urls = ''
      let params = {}

      if (this.$route.query.id === 'Sec_Structure') {
        urls = url.lncRNA_polt
        params.lncRNA_id = sessionStorage.getItem("lncRNA_id")
        this.http.get(urls, params).then(res => {
          this.message = res.data.data[0].file_svg
        }).catch(err => {
          console.log(err);
        });
      } else {
        if (this.$route.query.name == 'numMir') {
          urls = url.lncRNA_seq
          params.lncRNA_id = sessionStorage.getItem("lncRNA_id")
        } else {
          urls = url.gene_seq
          params.isoform_id = sessionStorage.getItem("isoform_id")
        }
        this.http.get(urls, params).then(res => {
          if (res.data.code == 200) {
            if (this.$route.query.id === 'GeneticSequence') {
              this.message = this.show(res.data.data[0].lncRNA_seq)
            // } else if (this.$route.query.id === 'Sec_Structure') {
            //   this.message = this.show(res.data.data[0].scd_structure)
            } else if (this.$route.query.id === 'Sequence') {
              this.message = this.show(res.data.data[0].pep_seq)
            } else if (this.$route.query.id === 'pep_seq') {
              this.message = this.show(res.data.data[0].pep_seq)
            } else if (this.$route.query.id === 'genomic_seq') {
              this.message = this.show(res.data.data[0].genomic_seq)
            } else if (this.$route.query.id === 'cds_seq') {
              this.message = this.show(res.data.data[0].cds_seq)
            }
          }
        }).catch(err => {
          console.log(err);
        });
      }
    },
    show(s) {
      let re = '';
      if (this.$route.query.name == 'numMir') {
        re = `>${sessionStorage.getItem("lncRNA_id")}<br />`
      } else {
        re = `>${sessionStorage.getItem("isoform_id")}<br />`
      }
      for (let i = 0; i < Math.ceil(s.length / 70); i++) {
        re += `${s.substr(i * 70, 70)}<br />`
      }
      return re;
    }
  }
};
</script>


<style scoped>
body {
  width: 100%;
  height: 100%;
}
.detail-page {
  /* display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; */
  width: 100%;
  height: 100%;
  /* background: #f3f3f3; */
}
.content {
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 10px;
  font-family: serif;
  font-size: 20px;
  box-sizing: border-box;
}
</style>
